import React from "react"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"

function HeaderForm({ title, description }) {
  return (
    <div>
      <Typograph htmlTag="h1" size="medium" weight="bold" color="outer_space">
        {title}
      </Typograph>

      <Typograph htmlTag="p" size="medium" weight="medium" color="outer_space">
        {description}
      </Typograph>
    </div>
  )
}
HeaderForm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}
export default HeaderForm



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/RequestForm/components/HeaderForm/index.js